/* Current Nostalgia - even product tiles (v95).
   Product photos are cut-outs or shot on white (the tile's multiply blend turns white into the
   tile colour), always centred, and clothing fills about 80% of the frame. Small things - coin
   pouches, air fresheners, darts, stickers - can fill a third of it, and a few photos run edge to
   edge. So each tile photo is measured once, from a 48px copy of the same file, and scaled so the
   piece fills a similar share of the tile: small pieces up (never past 1.6x), edge-to-edge ones in
   a little. The photo files are untouched. Measurements are kept in this browser, so a photo is
   only measured the first time it's seen. A landscape photo is fitted inside the square tile
   instead of having its sides cropped off. */
(function () {
  if (window.__cnTileFit) return;
  window.__cnTileFit = true;

  var SEL = '.product-card-wrapper .card__media .media img';
  var KEY = 'cnTileFit1';
  var cache = {};
  try { cache = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) {}
  var saveT = 0;
  function save() {
    clearTimeout(saveT);
    saveT = setTimeout(function () { try { localStorage.setItem(KEY, JSON.stringify(cache)); } catch (e) {} }, 500);
  }
  function keyOf(src) {
    try {
      var u = new URL(src, location.href);
      return u.pathname.split('/').pop() + '?' + (u.searchParams.get('v') || '');
    } catch (e) { return ''; }
  }

  var cv = null, ctx = null;
  function measure(src, done) {
    var u;
    try { u = new URL(src, location.href); } catch (e) { done(null); return; }
    u.searchParams.set('width', '48');
    u.searchParams.delete('height');
    u.searchParams.delete('crop');
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = im.naturalWidth, H = im.naturalHeight;
        if (!W || !H) { done(null); return; }
        cv = cv || document.createElement('canvas');
        ctx = ctx || cv.getContext('2d', { willReadFrequently: true });
        cv.width = W; cv.height = H;
        ctx.clearRect(0, 0, W, H);
        ctx.drawImage(im, 0, 0);
        var d = ctx.getImageData(0, 0, W, H).data;
        /* a cut-out if any corner is see-through, otherwise a photo on white; a full-bleed photo
           (no white corners) is left at its size */
        var corners = [0, (W - 1) * 4, (H - 1) * W * 4, ((H - 1) * W + W - 1) * 4];
        var cut = corners.some(function (i) { return d[i + 3] < 250; });
        var a = W / H;
        if (!cut && corners.some(function (i) { return d[i] < 238 || d[i + 1] < 238 || d[i + 2] < 238; })) {
          done({ f: 0, a: Math.round(a * 100) / 100 });
          return;
        }
        var x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var y = 0; y < H; y++) {
          for (var x = 0; x < W; x++) {
            var i = (y * W + x) * 4;
            if (cut ? d[i + 3] > 24 : (d[i] < 238 || d[i + 1] < 238 || d[i + 2] < 238)) {
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
        }
        if (x1 < 0) { done(null); return; }
        /* share of the square tile the piece covers, once the photo is fitted inside it */
        var bw = (x1 - x0 + 1) / W * Math.min(1, a);
        var bh = (y1 - y0 + 1) / H * Math.min(1, 1 / a);
        done({ f: Math.round(Math.max(bw, bh) * 100) / 100, a: Math.round(a * 100) / 100 });
      } catch (e) { done(null); }
    };
    im.onerror = function () { done(null); };
    im.src = u.toString();
  }

  function scaleFor(m) {
    if (!m || !m.f) return 1;
    if (m.f < 0.66) return Math.min(1.6, 0.72 / m.f);
    if (m.f > 0.96) return 0.9;
    return 1;
  }
  function apply(img, m) {
    img.setAttribute('data-cn-fit', '');
    if (!m) return;
    if (Math.abs(m.a - 1) > 0.05) img.classList.add('cn-fit-contain');
    var s = scaleFor(m);
    if (s !== 1) img.style.setProperty('--cn-fit', s.toFixed(3));
  }
  function fit(img) {
    if (img.hasAttribute('data-cn-fit')) return;
    var src = img.getAttribute('src') || img.currentSrc;
    if (!src) return;
    var k = keyOf(src);
    if (k && Object.prototype.hasOwnProperty.call(cache, k)) { apply(img, cache[k]); return; }
    img.setAttribute('data-cn-fit', 'pending');
    measure(src, function (m) {
      if (k) { cache[k] = m; save(); }
      img.removeAttribute('data-cn-fit');
      apply(img, m);
    });
  }

  /* measured photos apply at once; the rest are measured as they come near the screen */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      fit(e.target);
    });
  }, { rootMargin: '400px 0px' }) : null;
  function scan() {
    document.querySelectorAll(SEL).forEach(function (img) {
      if (img.__cnFitSeen) return;
      img.__cnFitSeen = true;
      var k = keyOf(img.getAttribute('src') || '');
      if (!io || (k && Object.prototype.hasOwnProperty.call(cache, k))) fit(img);
      else io.observe(img);
    });
  }
  window.cnTileFit = scan;
  var t = 0;
  if (window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 80); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();